import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getMetric } from 'services/metric.service';

export const getMetricQueryKey = 'getMetric';
export const useMetric = () => useQuery([getMetricQueryKey], () => getMetric()
  .then((result: AxiosResponse<Metric[]>) => result.data), {
  refetchOnWindowFocus: false, retry: false, cacheTime: 0,
}) as AxiosResponse<Metric[], Error>;
